/* ============================================================
   Pholoh sticky add-to-cart bar (PDP).
   - Appears when the real ATC button scrolls out of view.
   - Has its own size picker; the icon button AJAX-adds the chosen size's
     variant and dispatches Impulse's ajaxProduct:added (cart drawer opens).
   - Price updates to the selected size.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-pholoh-sticky]');
    if (!bar) return;

    var scope = document.getElementById(bar.dataset.section) || document;
    var mainBtn = scope.querySelector('[data-add-to-cart]');
    var addBtn = bar.querySelector('[data-pholoh-sticky-add]');
    var sizeSel = bar.querySelector('[data-pholoh-sticky-size]');
    var idInput = bar.querySelector('[name="id"]');
    var priceEl = bar.querySelector('[data-pholoh-sticky-price]');

    function selectedId() {
      if (sizeSel && sizeSel.value) return sizeSel.value;
      return idInput && idInput.value;
    }

    if (sizeSel) {
      sizeSel.addEventListener('change', function () {
        if (idInput) idInput.value = sizeSel.value;
        var opt = sizeSel.options[sizeSel.selectedIndex];
        if (opt && priceEl && opt.dataset.price) priceEl.innerHTML = opt.dataset.price;
      });
    }

    addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (addBtn.dataset.loading === '1') return;
      var id = selectedId();
      if (!id) return;
      addBtn.dataset.loading = '1';
      addBtn.classList.add('is-loading');

      var body = new FormData();
      body.append('id', id);
      body.append('quantity', 1);

      fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST', body: body,
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          addBtn.dataset.loading = '';
          addBtn.classList.remove('is-loading');
          if (data && (data.status === 422 || data.status === 'bad_request')) return;
          if (idInput) idInput.value = id;
          bar.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data, addToCartBtn: addBtn }, bubbles: true }));
        })
        .catch(function () {
          addBtn.dataset.loading = '';
          addBtn.classList.remove('is-loading');
        });
    });

    // Reveal when the real ATC button is scrolled out of view
    if (mainBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
      io.observe(mainBtn);
    } else {
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
